import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 6px;\n  top: 6px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { color } from '@scp/ui-shared/theme/variables'; // Avoid circular dependencies - import directly from file

import { Badge } from '@scp/ui-shared/components/badges';
import { IconButton } from './IconButton';
var ButtonWrapper = styled.div(_templateObject());
var ButtonComponent = withoutProps(IconButton, ['isActiveButton']);
var StyledButton = styled(ButtonComponent)(_templateObject2(), function (props) {
  return props.isActiveButton ? color.actionHover : props.color || color.icon;
});
var BadgeWrapper = styled.div(_templateObject3());
/**
 * An IconButtonWithBadge component.
 *
 * Used to add accessible enough clickable area and ripple effects on click or focus.
 * Extends `<IconButton />`. You can use all props of `<IconButton />`.
 *
 * @example ./__docs__/IconButtonWithBadge.md
 */

export var IconButtonWithBadge = function IconButtonWithBadge(_a) {
  var children = _a.children,
      buttonTitle = _a.buttonTitle,
      showBadge = _a.showBadge,
      badgeTitle = _a.badgeTitle,
      badgeCount = _a.badgeCount,
      active = _a.active,
      otherProps = __rest(_a, ["children", "buttonTitle", "showBadge", "badgeTitle", "badgeCount", "active"]);

  return React.createElement(ButtonWrapper, null, React.createElement(StyledButton, Object.assign({
    title: buttonTitle,
    isActiveButton: active
  }, otherProps), children), React.createElement(BadgeWrapper, null, React.createElement(Badge, {
    showEmpty: showBadge,
    title: badgeTitle,
    count: badgeCount
  })));
};